import React from "react";

// Default values
const AuthContext = React.createContext({
    isAuthenticated: false,
    isChecked: false,
    role: 'user',
    show: false,
    toggleLoginModal: () => { },
    login: () => { },
    logout: () => { },
    validate: async () => false
});

export default AuthContext;
